import React from 'react';

import { DropdownArrowIcon, DropdownIndicatorProps } from '../Dropdown';
import { MdArrowDropDown } from 'react-icons/md';

export const DropdownIndicator = (props: DropdownIndicatorProps) => {
  return (
    <DropdownArrowIcon menuIsOpen={props.selectProps.menuIsOpen}>
      <MdArrowDropDown size={18} opacity={0.5} />
    </DropdownArrowIcon>
  );
};
